var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pages-ccd-tenancy-details" },
    [
      _c(
        "TenancyHeader",
        { attrs: { tenancyId: _vm.currentTenancy.id } },
        [
          _c(
            "Sticky",
            {
              attrs: {
                extendStickyClass: "sticky-button--group",
                fullWidth: false,
                zIndex: Number(101),
                align: "right",
              },
            },
            [
              !_vm.isCreate
                ? _c(
                    "button",
                    {
                      directives: [
                        { name: "hkldreset", rawName: "v-hkldreset" },
                      ],
                      staticClass: "btn btn--darkblue",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.cancelEdit()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("action.cancel")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isCreate
                ? _c(
                    "button",
                    {
                      directives: [
                        { name: "hkldreset", rawName: "v-hkldreset" },
                      ],
                      staticClass: "btn btn--orange",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.companyNameCheckBeforeSaving()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("action.save")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isCreate
                ? _c(
                    "button",
                    {
                      directives: [
                        { name: "hkldreset", rawName: "v-hkldreset" },
                      ],
                      staticClass: "btn btn--orange",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.create()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("action.create")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tabs-container-wrapper" },
        [
          _c(
            "TabsContainer",
            {
              staticClass: "tabs-container",
              attrs: {
                tabNames: _vm.tabNames,
                getCurrentTab: _vm.getCurrentTab,
              },
            },
            [
              _c("TenancyInformation", {
                ref: "tenancyInfo",
                attrs: {
                  slot: "tab-" + _vm.tenancyEditTabs.tenancyInformation,
                  company: _vm.companyInfo,
                  companyId: _vm.companyId,
                  originLeases: _vm.keep.leases || [],
                  originPremises: _vm.keep.premises || "",
                  isCreate: _vm.isCreate,
                  allowEdit: _vm.allowEditInfo,
                  allowLinkContacts: _vm.allowLinkContacts,
                  allowUpdateMasterAccount: _vm.allowUpdateMasterAccount,
                },
                slot: "tab-" + _vm.tenancyEditTabs.tenancyInformation,
              }),
              _vm._v(" "),
              !_vm.isCreate
                ? _c(
                    "div",
                    {
                      attrs: { slot: "tab-" + _vm.tenancyEditTabs.allContacts },
                      slot: "tab-" + _vm.tenancyEditTabs.allContacts,
                    },
                    [
                      _c("TenantConfirm"),
                      _vm._v(" "),
                      _c("ECircularContact", {
                        ref: "eCircularContact",
                        attrs: {
                          companyId: _vm.companyInfoId,
                          tenancyId: _vm.tenancyId,
                          allowLinkContacts: _vm.allowLinkContacts,
                          linkFunc: _vm.goToLinkContact,
                        },
                      }),
                      _vm._v(" "),
                      _c("EmergencyContact", {
                        ref: "emergencyContact",
                        attrs: {
                          companyId: _vm.companyInfoId,
                          tenancyId: _vm.tenancyId,
                          allowLinkContacts: _vm.allowLinkContacts,
                          linkFunc: _vm.goToLinkContact,
                        },
                      }),
                      _vm._v(" "),
                      _c("FireMarshalContact", {
                        ref: "fireMarshalContact",
                        attrs: {
                          allowLinkContacts: _vm.allowLinkContacts,
                          linkFunc: _vm.goToLinkContact,
                        },
                      }),
                      _vm._v(" "),
                      _vm.isRetail
                        ? _c("MarketingContact", {
                            ref: "marketingContact",
                            attrs: {
                              companyId: _vm.companyInfoId,
                              tenancyId: _vm.tenancyId,
                              allowLinkContacts:
                                _vm.allowLinkContacts && _vm.canEditMarketing,
                              linkFunc: _vm.goToLinkContact,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("OthersContact", {
                        attrs: {
                          companyId: _vm.companyInfoId,
                          tenancyId: _vm.tenancyId,
                          allowLinkContacts: _vm.allowLinkContacts,
                          linkFunc: _vm.goToLinkContact,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isCreate
                ? _c("LeaseInformation", {
                    attrs: {
                      slot: "tab-" + _vm.tenancyEditTabs.leaseInformation,
                      isEdit: _vm.allowLinkLeases,
                    },
                    slot: "tab-" + _vm.tenancyEditTabs.leaseInformation,
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isCreate
                ? _c("UserManagement", {
                    ref: "userManagement",
                    attrs: {
                      slot: "tab-" + _vm.tenancyEditTabs.userManagement,
                      isEdit: true,
                      allowUpdateMasterAccount: _vm.allowUpdateMasterAccount,
                      allowInviteMaster: _vm.allowInviteMaster,
                    },
                    slot: "tab-" + _vm.tenancyEditTabs.userManagement,
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "renameConfirmModal",
        attrs: {
          modalId: "renameConfirmModalId",
          confirmTitle: _vm.$t(
            "tenancyRecords.confirm.companyNameCheckBeforeSaving"
          ),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }